import * as actions from "./actionTypes";

export const searchAccounts = (query: string) => {
  return { type: actions.SEARCH_ACCOUNTS, payload: { query } };
};

export const searchUsers = (query?: string) => {
  return { type: actions.SEARCH_USERS, payload: { query } };
};
